import React, { useState } from 'react';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { setProgressBarStatus } from 'src/pages/scheduleSurgery/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { SCHEDULESURGERYSTEPS } from 'src/constants/productConstants';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';

import {
    BackButtonContainer,
    MessageData,
    BackButtonIcon,
    BackText,
    Container,
    CloseIconContainer,
    CloseIcon,
    Header,
    AnnouncementContent,
    DesktopView,
    MobileView,
    BomCardsContainer,
    RegularText,
    Div,
    CardsContainer,
    MainContainerItems,
} from './BomNotification.styled';
// import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft.svg';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import Close from 'src/assets/images/CloseProduct.svg';
import ScrollView from 'src/common/components/scrollview/ScrollView';
import Card from 'src/common/refactoredComponents/card/Card';
import { isIpad, logErrorToConsole } from 'src/utils/util';

import {
    HeaderData,
    DemiText,
} from 'src/common/refactoredComponents/dataTable/DataTable.styled';
import { Subtitle } from 'src/pages/orders/components/orderDetails/backOrderDetails/BackOrderDetails.styled';
import { useTranslation } from 'react-i18next';
import { getDisplayDate } from 'src/utils/dateUtils';
import { sizes } from 'src/styles/Media.styled';
import { BASE_TEXT_PX, DARK_GRAY_FONT_COLOR, DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, LIST_VIEW_TABLE_CELL, PRIMARY_FONT_COLOR, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX, TITLE_FONT_COLOR, X_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

export default function index({
    closeBomModal = () => {},
    setDetails,
    isFromCart,
    handleSetItemClick,
    setBomNotification,
    setIsFromBomPopup
}) {
    const { t } = useTranslation();
    const iPad = isIpad();

    const { productBomDetails, productBomDetailsLoading } = useSelector(
        (state) => state.checkProductBomReducer
    );

    const preparedData = productBomDetails
        .filter((item) => {
            return (
                item.prodcutCFN === setDetails.productCFN ||
                item.prodcutCFN === setDetails.cfn
            );
        })
        .flatMap((item) => {
            if (item.billOfMaterialsHistory) {
                return item.billOfMaterialsHistory.map((historyItem) => ({
                    ...historyItem,
                    productCFN: item.prodcutCFN,
                }));
            }
            return [];
        });

    let colData = [
        {
            field: 'set',
        },
        {
            field: 'material',
        },
        {
            field: 'description',
        },
        {
            field: 'oldQuantity',
        },
        {
            field: 'newQuantity',
        },
        {
            field: 'modifiedDate',
        },
    ];

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                padding: 0,
            },
        };
        switch (column.field) {
            case 'set': 
                extraProps.header = (
                    <HeaderData>
                        <DemiText
                            color={PRIMARY_FONT_COLOR}
                            fontWeight="600" 
                            fontSize={X_SMALL_TEXT_PX}
                        >
                            {t('bomDetails.set')}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    paddingLeft: '0.5rem',
                    width: '20%',
                };
                extraProps.bodyStyle = {
                    paddingLeft: '0.5rem',
                    textAlign: 'left',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            <MessageData 
                            color = {TITLE_FONT_COLOR} 
                            fontFamily={FONT_FAMILY_DEMI}
                            fontWeight = {'bold'} 
                            wordWrap="break-word"
                            cursor={'pointer'}
                            onClick={() => {
                                try {
                                    setBomNotification(false);
                                    setIsFromBomPopup(true);
                                    handleSetItemClick(
                                        setDetails, false
                                    );
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                                    >
                                {/* {getDisplayDate(rowData.modifiedDate)} */}
                                {rowData.set}
                            </MessageData>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'material':
                extraProps.header = (
                    <HeaderData>
                        <DemiText
                            color={PRIMARY_FONT_COLOR}
                            fontWeight="600"
                            fontSize={X_SMALL_TEXT_PX}
                        >
                            {t('bomDetails.material')}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    paddingLeft: '0.5rem',
                    width: '25%',
                };
                extraProps.bodyStyle = {
                    paddingLeft: '0.5rem',
                    textAlign: 'left',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            <Subtitle fontSize={SMALL_TEXT_PX} width="100%">
                                <RegularText
                                    color={PRIMARY_FONT_COLOR}
                                    fontSize={SMALL_TEXT_PX}
                                    fontWeight="600"
                                    wordWrap="break-word"
                                >
                                    {/* {rowData?.description &&
                                            displayMessage(rowData.description)} */}
                                    {rowData.material}
                                </RegularText>
                            </Subtitle>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'description':
                extraProps.header = (
                    <HeaderData>
                        <DemiText
                            color={PRIMARY_FONT_COLOR}
                            fontWeight="600"
                            fontSize={X_SMALL_TEXT_PX}
                        >
                            {t('bomDetails.description')}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    paddingLeft: '0.5rem',
                    width: '60%',
                };
                extraProps.bodyStyle = {
                    paddingLeft: '0.5rem',
                    textAlign: 'left',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            <Subtitle fontSize={SEMANTIC_TEXT_SMALL_PX} width="100%">
                                <MessageData wordWrap="break-word">
                                    {/* {rowData?.description &&
                                            displayMessage(rowData.description)} */}
                                    {rowData.description}
                                </MessageData>
                            </Subtitle>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'oldQuantity':
                extraProps.header = (
                    <HeaderData>
                        <DemiText
                            color={PRIMARY_FONT_COLOR}
                            fontWeight="600"
                            fontSize={X_SMALL_TEXT_PX}
                        >
                            {t('bomDetails.oldQuantity')}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    paddingLeft: '0.5rem',
                    paddingRight: '0.5rem',
                    width: '25%',
                    textAlign: 'center',
                };
                extraProps.bodyStyle = {
                    paddingLeft: '1rem',
                    paddingRight: '0.5rem',
                    width: '25%',
                    textAlign: 'center',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            <Subtitle fontSize={SMALL_TEXT_PX} width="100%">
                                <MessageData
                                    textAlign="center"
                                    fontWeight={'600'}
                                >
                                    {parseInt(rowData.oldQuantity, 10)}
                                </MessageData>
                            </Subtitle>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'newQuantity':
                extraProps.header = (
                    <HeaderData>
                        <DemiText
                            color={PRIMARY_FONT_COLOR}
                            fontWeight="600"
                            fontSize={X_SMALL_TEXT_PX}
                        >
                            {t('bomDetails.newQuantity')}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    paddingLeft: '0.5rem',
                    paddingRight: '0.5rem',
                    width: '25%',
                    textAlign: 'center',
                };
                extraProps.bodyStyle = {
                    paddingLeft: '1rem',
                    paddingRight: '0.5rem',
                    width: '25%',
                    textAlign: 'center',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            <Subtitle fontSize={SMALL_TEXT_PX} width="100%">
                                <MessageData
                                    textAlign={'center'}
                                    fontWeight={'600'}
                                >
                                    {/* {rowData?.description &&
                                                    displayMessage(rowData.description)} */}
                                    {/* {parseInt(rowData.newQuantity, 10)} */}
                                    <span style={{ textAlign: 'center' }}>
                                        {parseInt(rowData.newQuantity, 10)}
                                    </span>
                                </MessageData>
                            </Subtitle>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'modifiedDate':
                extraProps.header = (
                    <HeaderData>
                        <DemiText
                            color={PRIMARY_FONT_COLOR}
                            fontWeight="600"
                            fontSize={X_SMALL_TEXT_PX}
                        >
                            {t('bomDetails.validFrom')}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    // paddingLeft: '0.5rem',
                    textAlign: 'left',
                    width: '27%',
                };
                extraProps.bodyStyle = {
                    paddingLeft: '0.5rem',
                    textAlign: 'left',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            <Subtitle fontSize={SMALL_TEXT_PX} width="100%">
                                <MessageData wordWrap="break-word">
                                    {/* {rowData?.description &&
                                                        displayMessage(rowData.description)} */}
                                    {getDisplayDate(rowData.modifiedDate)}
                                </MessageData>
                            </Subtitle>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    const dispatch = useDispatch();

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );
    const handleNavigation = () => {
        dispatch(setProgressBarStatus(SCHEDULESURGERYSTEPS[2]));
    };

    return (
        <>
            <DesktopView>
                <Header>
                    <BackButtonContainer
                        // onClick={discardSearchModal}
                        onClick={closeBomModal}
                        margin={'0'}
                        style={{ cursor: 'pointer' }}
                    >
                        <BackButtonIcon margin={'0 0 0 0px'} src={BackIcon} />
                        <BackText mbDisplay={'none'}>
                            {isFromCart
                                ? t('scheduleSurgery.cart.backToCart')
                                : t('scheduleSurgery.details.backToTemplate')}
                        </BackText>
                    </BackButtonContainer>
                    {/* <CloseIconContainer>
                        <CloseIcon
                            mobilePath={Close}
                            // onClick={() => setViewTemplate(false)}
                            show={true}
                            onClick={closeBomModal}
                        />
                    </CloseIconContainer> */}
                </Header>
                <div style={{margin:'0 10px'}}>
                <MessageData fontSize={BASE_TEXT_PX} color={DARK_NAVY_FONT_COLOR}>
                    {t('scheduleSurgery.details.messageData')}
                    <span style={{ color: DARK_NAVY_FONT_COLOR, fontFamily: FONT_FAMILY_DEMI, fontWeight: 600 }}>
                        {'  '} {setDetails.productCFN || setDetails.cfn}
                    </span>
                </MessageData>
                <AnnouncementContent>
                    <ScrollView maxHeight="70vh">
                        {/* {bomData.billOfMaterialsHistory?.map((data, index) =>
                        data && data?.set ? (
                            <React.Fragment key={`${data.set}_${index}`}>
                                <BoxContainer
                                    marginBottom={
                                        bomData.length - 1 === index && '20vh'
                                    }
                                >
                                    <StyledDate>
                                          {getDisplayDate(data.startDate)}  
                                        {data.set}
                                    </StyledDate>
                                </BoxContainer>
                            </React.Fragment>
                        ) : null
                    )} */}
                        <Div>
                            <Datatable
                                id={'surgery-cart-sets-bomNotification'}
                                padding='10px'
                                backgroundColorOdd={'#FFFFFF99'}
                                backgroundColorEven={'#F5F5F5'}
                                resizableColumns
                                columns={colData}
                                data={preparedData}
                                scrollable
                                scrollHeight={
                                    window.innerWidth >= sizes.smalDevice &&
                                    window.innerWidth < sizes.mediumDevice
                                        ? 'calc(100vh - 27rem)'
                                        : 'calc(100vh - 22rem)'
                                }
                                height={'auto'}
                                rows={50}
                            />
                        </Div>
                    </ScrollView>
                </AnnouncementContent>
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignContent: 'center',
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        backgroundColor: 'white',
                        width: '100%',
                        paddingRight: '1%'
                    }}
                >
                    <Button
                        id={'surgery-cart-bomnotification-close'}
                        show={true} 
                        width={'100px'}
                        height={'38px'}
                        variant={ButtonStyles?.primary}
                       // primary={true}
                        borderRadius={'19px'}
                        margin={'10px'}
                        fontSize={'15px'}
                        fontFamily={'AvenirNextWorld Demi'}
                        clicked={closeBomModal}
                    >
                        <div style={{ whiteSpace: 'nowrap' }}>
                            {t('common.closeButton')}
                        </div>
                    </Button>
                </div>
            </DesktopView>
            <MobileView flexGrow="1" overFlowY="scroll" overFlowX="hidden">
                <BomCardsContainer>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            margin: '20px 25px 0px 20px'
                        }}
                    >
                        <BackButtonContainer
                            onClick={closeBomModal}
                            margin={'0'}
                            style={{ cursor: 'pointer' }}
                        >
                            <BackButtonIcon src={BackIcon} />
                            <BackText style={{ fontWeight: '600', fontFamily: 'AvenirNextWorld Demi' }}>
                                {isFromCart
                                    ? t('scheduleSurgery.cart.backToCart')
                                    : t('scheduleSurgery.details.backToTemplate')}
                            </BackText>
                        </BackButtonContainer>
                        <CloseIconContainer>
                            {/* <CloseIcon
                                mobilePath={Close}
                                show={true}
                                onClick={closeBomModal}
                            /> */}
                        </CloseIconContainer>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            margin: '10px 25px 20px 25px',
                        }}
                    >
                        <RegularText
                            color={DARK_NAVY_FONT_COLOR}
                            fontSize={BASE_TEXT_PX}
                            margin="10px"
                            fontWeight="400"
                        >
                            {t('scheduleSurgery.details.messageData')}
                            <span
                                id={`bom-notification-set-${setDetails.productCFN || setDetails.cfn}`}
                                style={{ color: DARK_NAVY_FONT_COLOR, fontFamily: FONT_FAMILY_DEMI, fontWeight: 600 }}
                                // onClick={() => {
                                //     setBomNotification(false);
                                //     setIsFromBomPopup(true);
                                //     handleSetItemClick(
                                //         setDetails, false
                                //     );
                                // }}
                            >
                                {' '}
                                {setDetails.productCFN || setDetails.cfn}
                            </span>
                        </RegularText>
                    </div>
                    <CardsContainer>
                        {preparedData?.map((bom, index) => {
                            return (
                                <Card
                                    border="2px dashed #A8A8A8"
                                    mobileMargin={'0px 0px 0px 0px'}
                                    mobileMaxWidth={'85%'}
                                    key={index}
                                    background={index % 2 ? '' : '#F5F5F5'}
                                    isHideBoxShadow={true}
                                    justifyContent={'left'}
                                >
                                    <div
                                        style={{
                                            flexDirection: 'column',
                                            alignItems: 'flex-start !important',
                                            paddingBottom: '10px',
                                            marginLeft: '15px',
                                        }}
                                    >
                                        <DemiText
                                            mbFontSize={SMALL_TEXT_PX}
                                            color={DARK_GRAY_FONT_COLOR}
                                        //    // fontWeight="700 !important"
                                            fontFamily="AvenirNextWorld Demi"
                                        >
                                            {t('bomDetails.set')}
                                        </DemiText>
                                        <RegularText
                                            color={TITLE_FONT_COLOR}
                                            fontSize={X_SMALL_TEXT_PX}
                                            fontWeight="600"
                                            fontFamily="AvenirNextWorld Demi"
                                            cursor={'pointer'}
                                            onClick={() => {
                                                try {
                                                    setBomNotification(false);
                                                    setIsFromBomPopup(true);
                                                    handleSetItemClick(
                                                        setDetails, false
                                                    );
                                                } catch (error) {
                                                    logErrorToConsole(error);
                                                }
                                            }}
                                        >
                                            {bom.set}
                                        </RegularText>
                                        <DemiText
                                            mbFontSize={SMALL_TEXT_PX}
                                            color={DARK_GRAY_FONT_COLOR}
                                            // fontWeight="700 !important"
                                            fontFamily="AvenirNextWorld Demi"
                                        >
                                            {t('bomDetails.material')}
                                        </DemiText>
                                        <RegularText
                                            color={LIST_VIEW_TABLE_CELL}
                                            fontSize={SEMANTIC_TEXT_SMALL_PX}
                                            fontWeight="400"
                                            fontFamily="AvenirNextWorld Regular"
                                            wordWrap="break-word"
                                            // margin="2px"
                                        >
                                            {bom.material}
                                        </RegularText>
                                        <DemiText
                                            mbFontSize={SMALL_TEXT_PX}
                                            color={DARK_GRAY_FONT_COLOR}
                                            // fontWeight="700 !important"
                                            fontFamily="AvenirNextWorld Demi"
                                        >
                                            {t('bomDetails.description')}
                                        </DemiText>

                                        <RegularText
                                            color={LIST_VIEW_TABLE_CELL}
                                            fontSize={SEMANTIC_TEXT_SMALL_PX}
                                            fontWeight="400"
                                            wordWrap="break-word"
                                            // margin="2px"
                                        >
                                            {bom.description}
                                        </RegularText>
                                        <div
                                            style={{
                                                flexDirection: 'row',
                                                display: 'flex',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    flexDirection: 'column',
                                                    display: 'flex',
                                                    paddingRight: '20px',
                                                }}
                                            >
                                                <DemiText
                                                    mbFontSize={SMALL_TEXT_PX}
                                                    color={DARK_GRAY_FONT_COLOR}
                                                   // fontWeight="700 !important"
                                                    fontFamily="AvenirNextWorld Demi"
                                                >
                                                    {t(
                                                        'bomDetails.oldQuantity'
                                                    )}
                                                </DemiText>

                                                <span
                                                    style={{
                                                        color: {LIST_VIEW_TABLE_CELL},
                                                        fontSize: {BASE_TEXT_PX},
                                                        textAlign: 'center',
                                                        fontWeight: '400',
                                                    }}
                                                    // margin="2px"
                                                >
                                                    {parseInt(
                                                        bom.oldQuantity,
                                                        10
                                                    )}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    flexDirection: 'column',
                                                    display: 'flex',
                                                }}
                                            >
                                                <DemiText
                                                    mbFontSize={SMALL_TEXT_PX}
                                                    color={DARK_GRAY_FONT_COLOR}
                                                   // fontWeight="700 !important"
                                                    fontFamily="AvenirNextWorld Demi"
                                                >
                                                    {t(
                                                        'bomDetails.newQuantity'
                                                    )}
                                                </DemiText>

                                                <span
                                                    style={{
                                                        color: {LIST_VIEW_TABLE_CELL},
                                                        fontSize: {BASE_TEXT_PX},
                                                        textAlign: 'center',
                                                        fontWeight: '400',
                                                    }}
                                                    // margin="2px"
                                                >
                                                    {parseInt(
                                                        bom.newQuantity,
                                                        10
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        <DemiText
                                           mbFontSize={SMALL_TEXT_PX}
                                           color={DARK_GRAY_FONT_COLOR}
                                           // fontWeight="700 !important"
                                           fontFamily="AvenirNextWorld Demi"
                                        >
                                            {t('bomDetails.validFrom')}
                                        </DemiText>

                                        <RegularText
                                            color={LIST_VIEW_TABLE_CELL}
                                            fontSize={X_SMALL_TEXT_PX}
                                            fontWeight="400"
                                            // margin="2px"
                                        >
                                            {getDisplayDate(bom.modifiedDate)}
                                        </RegularText>
                                    </div>
                                </Card>
                            );
                        })}
                    </CardsContainer>
                </BomCardsContainer>
                <div
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        backgroundColor: 'white',
                        padding: '10px',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '92%',
                    }}
                >
                    <Button
                        id={'surgery-cart-bomnotification-backtocart'}
                        show={true}
                        width={'100%'}
                        height={'38px'}
                        variant={ButtonStyles?.primary}
                        //primary={true}
                        borderRadius={'19px'}
                        margin={'5px'}
                        fontSize={'15px'}
                        fontFamily={'AvenirNextWorld Demi'}
                        clicked={closeBomModal}
                    >
                        <div style={{ whiteSpace: 'nowrap', fontWeight: '700 !important' }}>
                            {t('common.closeButton')}
                        </div>
                    </Button>
                </div>
            </MobileView>
        </>
    );
}
